import script from "./CreateCommentModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateCommentModal.vue?vue&type=script&lang=ts&setup=true"

import "./CreateCommentModal.vue?vue&type=style&index=0&id=5605a637&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5605a637"]])

export default __exports__